import { lazy, Suspense, type ComponentType } from 'react';
import type { RouteObject } from 'react-router-dom';
import ROUTES from '@/shared/constants/routes';
import DeclarationsSplitLayout from '../views/DeclarationsSplitLayout';

const YearView = lazy(() => import('../views/DeclarationsNewYearView'));
const PeriodView = lazy(() => import('../views/DeclarationsNewPeriodView'));
const InvoicesView = lazy(() => import('../views/DeclarationsNewInvoicesView'));
const CatchUpView = lazy(() => import('../views/DeclarationsNewCatchUpView'));
const ApproveManyView = lazy(() => import('../views/DeclarationsNewApproveManyView'));

const Lazy = ({ View }: { View: ComponentType }) => (
	<Suspense fallback={null}>
		<View />
	</Suspense>
);

export const declarationsRoutes: RouteObject[] = [
	{
		path: ROUTES.DECLARATIONS,
		element: <DeclarationsSplitLayout />,
		children: [
			{
				id: 'declarations',
				index: true,
				element: (
					<Lazy View={YearView} />
				),
			},
			{
				id: 'declarationsCatchUp',
				path: ROUTES.DECLARATIONS_CATCH_UP,
				element: (
					<Lazy View={CatchUpView} />
				),
			},
			{
				id: 'declarationsApproveMany',
				path: ROUTES.DECLARATIONS_APPROVE_MANY,
				element: (
					<Lazy View={ApproveManyView} />
				),
			},
			{
				id: 'declarationPeriod',
				path: ROUTES.DECLARATION_PERIOD,
				element: (
					<Lazy View={PeriodView} />
				),
			},
			{
				id: 'declarationInvoices',
				path: ROUTES.DECLARATION_INVOICES,
				element: (
					<Lazy View={InvoicesView} />
				),
			},
			{
				id: 'declarationInvoice',
				path: ROUTES.DECLARATION_INVOICE,
				element: (
					<Lazy View={InvoicesView} />
				),
			},
		],
	},
];
